const xss = function (msg) {
  msg = msg + ''
  msg = msg.replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
  .replace(/\'/g, '&#39;')
  .replace(/\"/g, '&quot;')

  return msg
}

export default xss
